import { render, staticRenderFns } from "./AgentCosts.vue?vue&type=template&id=97e4de6e&"
import script from "./AgentCosts.vue?vue&type=script&lang=ts&"
export * from "./AgentCosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports